/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var GrabberMoveCardIcon = createIcon("GrabberMoveCardIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#767676';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "31",
    height: "9",
    viewBox: "0 0 31 9",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M3 1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0Zm0 6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0Zm7-6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0Zm0 6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0Zm7-6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0Zm0 6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0Zm7-6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0Zm0 6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0Zm7-6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0Zm0 6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});